import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsFeaturesRoute: InvariantJiraRoute = {
	name: 'classic-software-features',
	path: '/jira/software/c/projects/:projectKey/settings/features',
	exact: true,
};
